// /src/components/donate/supportChoice/supportChoiceApi.js

import axios from 'axios';

const AUTH = { withCredentials: true };
const SKIP_VIEW_AS = { skipViewAs: true, withCredentials: true };

export async function fetchMySupportStatusForPopup() {
  const res = await axios.get('/api/kofi/my-support-status', AUTH);
  return res.data;
}

export async function confirmSupportChoiceForPopup(level, mode = 'pending') {
  const res = await axios.post(
    '/api/kofi/my-support-choice',
    { level, mode },
    AUTH,
  );
  return res.data;
}

/** Resume pointer stays on the authenticated socket user, not the view-as subject. */
export async function supportChoiceLastSeen(lastSeenWsLogId) {
  const res = await axios.post(
    '/api/user/support-choice-last-seen',
    { lastSeenWsLogId },
    SKIP_VIEW_AS,
  );
  return res.data;
}

export async function getSupportChoiceDiff() {
  const res = await axios.post('/api/user/support-choice-diff', {}, SKIP_VIEW_AS);
  return res.data;
}
